import * as S from './PropertyAddress.styled'

const PropertyAddress = ({ listing, offmarketUnlocked }) => {
  const {
    offmarket,
    offmarket_status,
    address_display,
    address_street_display,
    address_suburb,
    address_state,
    address_postcode,
    status,
  } = listing

  const renderAddress = () => {
    if (offmarket && !offmarketUnlocked) {
      if (offmarket_status === 'sold') {
        return address_display ? (
          <>
            {address_street_display}
            <br />
          </>
        ) : (
          'Contact agent for full address'
        )
      }
      return 'Unlock to view address'
    }

    return address_street_display ? (
      <>
        {address_street_display}
        <br />
      </>
    ) : (
      ''
    )
  }

  return (
    <S.PropertyAddress>
      {renderAddress()}
      <strong>{address_suburb}</strong> {address_state} {address_postcode}{' '}
      {status === 'leased' ? ' - Leased' : ''}
    </S.PropertyAddress>
  )
}

export default PropertyAddress
